export default {
  'claims': 'Afirmars',  
  'claims_v2': 'Afirmars v2',
  'operationalReports': 'Informes Operativos',
  'tireRackScorecard': 'Tablero de Tire Rack',
  'reports': 'Informes',
  'claimSearch': 'Búsqueda de Reclamaciones',
  'claimSearch_v2': 'Búsqueda de Reclamaciones v2',
  'dealerRegistration': 'Registro de distribuidor',
  'addProducts': 'Agregar productos',
  'registerDealer': 'Registrarse Distribuidor',
  'dealerSubmissions': 'Envíos del distribuidor',
};